import React from 'react';
import s from './ErrorTooltip.module.scss';

const ErrorTooltip = ({ message, visible = false }) => {
  if (!visible || !message) return null;

  return (
    <div className={s.errorTooltip}>
      {message}
    </div>
  );
};

export default ErrorTooltip;
